<template>
	<div style="padding: 200px 0 0 0;">
		<img src="../../assets/images/ufly_cloud.png" alt="" style="display: block;width: 180px;margin: 0 auto;">
		<p style="margin-top: 40px;font-size: 18px;text-align: center;line-height: 24px;">网络错误，请刷新重试。。。</p>
		<div style="margin-top: 20px;text-align: center;">
			<el-button type="primary" style="padding: 10px 40px;font-size: 16px;" @click="handleRefreshClick">刷新</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			// 点击刷新
			handleRefreshClick() {
				this.$emit('onRefresh');
			}
		}
	}
</script>

<style>
</style>
